module.exports = __webpack_public_path__ + "media/images/client-orange-theory-2-c6e34248bd7243e2a83be70980526a3f.png";